export const LANGUAGES = [
  { code: "en-GB", label: "English (UK)", nativeName: "English (UK)" },
  { code: "pl", label: "Polish", nativeName: "Polski" },
  { code: "ro", label: "Romanian", nativeName: "Română" },
  { code: "pa", label: "Punjabi", nativeName: "ਪੰਜਾਬੀ" },
  { code: "ur", label: "Urdu", nativeName: "اردو" },
  { code: "pt", label: "Portuguese", nativeName: "Português" },
  { code: "uk", label: "Ukrainian", nativeName: "Українська" },
];

export const DEFAULT_LANGUAGE = "en-GB";

export const languageLabel = (code) =>
  LANGUAGES.find((language) => language.code === code)?.label || code || "English (UK)";
